<div>
    <ng-container *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewOpinionScaleTypes.numerical">
        <div
            class="opinion-numerical-type"
            *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewOpinionScaleTypes.numerical"
        >
            <div *ngFor="let number of opinionScaleNumbers; let index = index">
                <div
                    (click)="onClick(number)"
                    class="opinion-numerical-type-number"
                    [ngClass]="{ active: value === index + 1 }"
                >
                    <span>{{ number }}</span>
                </div>
                <div *ngIf="index === 0 && interviewQuestion.questionValues[0]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[0] }}
                </div>
                <div *ngIf="index === 2 && interviewQuestion.questionValues[1]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[1] }}
                </div>
                <div *ngIf="index === 4 && interviewQuestion.questionValues[2]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[2] }}
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewOpinionScaleTypes.stars">
        <div
            *ngIf="interviewQuestion.questionTypeMode === jobPostingInterviewOpinionScaleTypes.stars"
            class="opinion-stars-type"
        >
            <div *ngFor="let _ of opinionScaleStars; let index = index">
                <div class="opinion-scale-star-type">
                    <img
                        #refEl
                        (click)="onClick(_)"
                        (mouseenter)="onMouseEnter(index)"
                        (mouseleave)="onMouseLeave(index)"
                        [src]="getImgSrc(index)"
                    />
                </div>
                <div *ngIf="index === 0 && interviewQuestion.questionValues[0]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[0] }}
                </div>
                <div *ngIf="index === 2 && interviewQuestion.questionValues[1]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[1] }}
                </div>
                <div *ngIf="index === 4 && interviewQuestion.questionValues[2]" class="opinion-scale-question-value">
                    {{ interviewQuestion.questionValues[2] }}
                </div>
            </div>
        </div>
    </ng-container>
</div>
